module.exports = __webpack_public_path__ + "img/febi-swag-blue-print.42bd948f.svg";